module.exports = "/images/zoo.svg?197da75c10a5ed336886b067a88b0c8d";